<template>
  <div style="width: 900px;" id="printArea">
    <h3 style="display: flex;justify-content: center;">{{tableData.title || ''}}</h3>
    <div style="width: 100%;">
      <table border="1" cellpadding="0" cellspacing="0" style="width:100%;">
        <tr>
          <td colspan="1">机构名称</td>
          <td colspan="5">{{tableData.fixMedinsName || ''}}</td>
          <td colspan="1">机构编码</td>
          <td colspan="2">{{tableData.fixMedinsCode || ''}}</td>
          <td colspan="2">医保结算级别</td>
          <td colspan="1">{{tableData.settlementLevel || ''}}</td>
        </tr>
        <tr>
          <td colspan="2">就医登记号</td>
          <td colspan="3">{{tableData.xxxxx || ''}}</td>
          <td colspan="1">结算号</td>
          <td colspan="6">{{tableData.setlId || ''}}</td>
        </tr>
        <tr>
          <td colspan="12">-</td>
        </tr>
        <tr>
          <td>姓名</td>
          <td colspan="2">{{tableData.patientName || ''}}</td>
          <td>性别</td>
          <td>{{tableData.gend || ''}}</td>
          <td>出生日期</td>
          <td>{{tableData.brdy || ''}}</td>
          <td>人员编号</td>
          <td colspan="2">{{tableData.psnNo || ''}}</td>
          <td>人员类别</td>
          <td>{{tableData.psnTypeName || ''}}</td>
        </tr>
        <tr>
          <td>单位名称</td>
          <td colspan="4">{{tableData.empName || ''}}</td>
          <td>联系电话</td>
          <td>{{tableData.mobile || ''}}</td>
          <td>身份证号</td>
          <td colspan="4">{{tableData.idCard || ''}}</td>
        </tr>
        <tr>
          <td style="width: 75px;">住院号</td>
          <td style="width: 75px;">{{tableData.hospitalNo || ''}}</td>
          <td style="width: 75px;">科别</td>
          <td style="width: 75px;">{{tableData.dept || ''}}</td>
          <td style="width: 75px;">床号</td>
          <td style="width: 75px;">{{tableData.bedNo || ''}}</td>
          <td style="width: 75px;">入院日期</td>
          <td style="width: 75px;">{{tableData.inHospDate || ''}}</td>
          <td style="width: 75px;">出院日期</td>
          <td style="width: 75px;">{{tableData.outHospDate || ''}}</td>
          <td style="width: 75px;">住院天数</td>
          <td style="width: 75px;">{{tableData.hospitalDays || ''}}</td>
        </tr>
        <tr>
          <td>险种</td>
          <td>{{tableData.insutypeName || ''}}</td>
          <td colspan="2">入院第一诊断</td>
          <td colspan="2">{{tableData.inHospDiag || ''}}</td>
          <td colspan="3">出院第一诊断</td>
          <td colspan="3">{{tableData.outHospDiag || ''}}</td>
        </tr>
        <tr>
          <td>业务类别</td>
          <td colspan="5">{{tableData.medTypeName || ''}}</td>
          <td>结算时间</td>
          <td colspan="5">{{tableData.setlTime || ''}}</td>
        </tr>
        <tr>
          <td colspan="12">-</td>
        </tr>
        <tr>
          <td colspan="12">
            {{ tableData.medTreatementDesc }}
          </td>
        </tr>
        <tr>
          <td colspan="12">-</td>
        </tr>
        <tr>
          <td>费用名称</td>
          <td colspan="2">总费用</td>
          <td>自费</td>
          <td colspan="2">部分項目自付</td>
          <td>费用名称</td>
          <td colspan="2">总费用</td>
          <td>自费</td>
          <td colspan="2">部分項目自付</td>
        </tr>
        <tr v-for="(item, index) in new Array(parseInt(chrgitmList.length/2)).fill(0)">
          <td>{{chrgitmList[2 * index].chrgitmName}}</td>
          <td colspan="2">{{chrgitmList[2 * index].detItemFeeSumamt}}</td>
          <td>{{chrgitmList[2 * index].partText}}</td>
          <td colspan="2">{{chrgitmList[2 * index].preselfpayAmt}}</td>
          <td>{{chrgitmList[2 * index + 1].chrgitmName}}</td>
          <td colspan="2">{{chrgitmList[2 * index + 1].detItemFeeSumamt}}</td>
          <td>{{chrgitmList[2 * index + 1].partText}}</td>
          <td colspan="2">{{chrgitmList[2 * index + 1].preselfpayAmt}}</td>
        </tr>
        <tr>
          <td colspan="12">-</td>
        </tr>
        <tr>
          <td colspan="3">基本医疗保险统筹基金支付</td>
          <td colspan="3">{{tableData.hifpPay}}</td>
          <td colspan="3">大額基金支付</td>
          <td colspan="3">{{tableData.hifpPay}}</td>
        </tr>
        <tr>
          <td colspan="3">大病基金支付</td>
          <td colspan="3">{{tableData.hifmiPay}}</td>
          <td colspan="3">平安佛医保理赔金额</td>
          <td colspan="3">{{tableData.pingAnFoPay}}</td>
        </tr>
        <tr>
          <td colspan="3">医疗救助基金支付</td>
          <td colspan="3">{{tableData.mafPay}}</td>
          <td colspan="3">公务员补助支付</td>
          <td colspan="3">{{tableData.cvlservPay}}</td>
        </tr>
        <tr>
          <td colspan="3">其他基金支付</td>
          <td colspan="3">{{tableData.othPay}}</td>
          <td colspan="3">个人账户支付</td>
          <td colspan="3">{{tableData.acctPay}}</td>
        </tr>
        <tr>
          <td colspan="12">
            {{tableData.inListSubsDesc}}
          </td>
        </tr>
        <tr>
          <td colspan="12">
            {{tableData.inListSubsDesc}}
          </td>
        </tr>
        <tr>
          <td colspan="12">
            {{tableData.inListSubsDesc}}
          </td>
        </tr>
        <tr>
          <td colspan="12">
            {{tableData.inListSubsDesc}}
          </td>
        </tr>
        <tr>
          <td colspan="1">收款人：</td>
          <td colspan="2">{{tableData.createUserName || ''}}</td>
          <td colspan="1">审核人：</td>
          <td colspan="2">{{tableData.createUserName || ''}}</td>
          <td colspan="1">制单人：</td>
          <td colspan="2">{{tableData.createUserName || ''}}</td>
          <td colspan="1">打印日期：</td>
          <td colspan="2">{{tableData.printTime || ''}}</td>
        </tr>
        <tr>
          <td colspan="12">
            <div style="text-align:left;">
              <p>注: 1、 部分项目自付金额是指基本医疗保险范国内的项目需参保人先按规定比例自付的金额。</p>
              <p style="margin-left: 22px;">2、此表由医院打印。</p>
              <p style="margin-left: 22px;">3、此表一式两份，医院、参保人各一份。</p>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="12" style="height: 44px;" rowspan="2">
            <div style="text-align:left;">
              <div>病人家属签字：</div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "guangdongPrintModel",
  data() {
    return {
      tableData: {
        chrgitmList: [],
      },
    };
  },
  methods: {
    handlePrint() {
      let dom = document.querySelector('#printArea');
      dom.style.display = 'block';
      this.$print(dom);
    },
  },

  computed: {
    chrgitmList() {
      let list = this.tableData.chrgitmList || [];
      list.forEach((item) => {
        if (item.fulamtOwnpayAmt && item.overlmtAmt) {
          let nu = parseFloat(item.fulamtOwnpayAmt) + parseFloat(item.overlmtAmt);
          item.partText = nu.toFixed(2);
        }
      })
      if (list.length % 2 === 1) {
        list.push({
          chrgitmName: '',
          detItemFeeSumamt: '',
          preselfpayAmt: '',
          fulamtOwnpayAmt: '',
          overlmtAmt: '',
          partText: '',
        })
      }
      return list || [];
    }
  }
};
</script>
<style lang="less" scoped>
#printArea td {
  text-align: center;
  height: 24px;
}
</style>
